import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';

import { Card, CardHeader, Box } from '@mui/material';

import { useChart } from '../../../components/chart';

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, ...other }) {
  const safeChartLabels = Array.isArray(chartLabels) ? chartLabels : [];

  const safeChartData = Array.isArray(chartData)
    ? chartData.map((item) => ({
        ...item,
        data: Array.isArray(item?.data)
          ? item.data.map((value) => {
              const numericValue = Number(value ?? 0);
              return Number.isFinite(numericValue) ? numericValue : 0;
            })
          : [],
      }))
    : [];

  const allValues = safeChartData.flatMap((series) => series.data);
  const maxDataValue = allValues.length > 0 ? Math.max(...allValues) : 0;
  const tickAmount = Math.max(2, Math.min(6, Math.ceil(maxDataValue) + 1));

  const chartOptions = useChart({
    plotOptions: {
      bar: {
        columnWidth: '10%',
      },
    },
    labels: safeChartLabels,
    xaxis: {
      type: 'text',
      labels: {
        style: { fontSize: '14px' },
      },
    },
    yaxis: {
      min: 0,
      tickAmount,
      labels: {
        formatter(value) {
          if (Number.isInteger(value)) {
            return value;
          }
          return '';
        },
        style: {
          fontSize: '11px',
        },
      },
    },
    tooltip: {
      y: {
        formatter(value) {
          return Math.round(value);
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <Box sx={{ p: 1, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={safeChartData} options={chartOptions} height={395} />
      </Box>
    </Card>
  );
}
